import { createFileRoute } from '@tanstack/react-router'
import { GlobalActivityLog } from '../../components/GlobalActivityLog'

// Organization-wide activity feed. All four filters live in the URL search
// params so the view is bookmarkable (routing-state convention).
//
// `cursor` is the resume marker rather than a filter: it holds an entry's
// created_at and restarts the feed there, making a deep infinite-scroll
// position bookmarkable and shareable.
export type ActivitySearch = {
  from?: string
  to?: string
  entity_table?: string
  user_uid?: string
  operation?: string
  cursor?: string
  // Free-text search (spec 2026-09-25-03-activity-feed-text-search.md). Same
  // filter as every other one here: lives in the URL, resets `cursor` and
  // pagination on change.
  q?: string
}

export const Route = createFileRoute('/$org/activity')({
  component: GlobalActivityLog,
  validateSearch: (search: Record<string, unknown>): ActivitySearch => ({
    from: (search.from as string) || undefined,
    to: (search.to as string) || undefined,
    entity_table: (search.entity_table as string) || undefined,
    user_uid: (search.user_uid as string) || undefined,
    operation: (search.operation as string) || undefined,
    cursor: (search.cursor as string) || undefined,
    q: (search.q as string) || undefined,
  }),
})
